// Mirror of backend normalize_phone(): 10 digits starting 6-9, else null.
export function normalizePhone(input) {
  let d = String(input ?? "").trim().replace(/\D/g, "");
  if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
  else if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
  return /^[6-9]\d{9}$/.test(d) ? d : null;
}

export const INVALID_PHONE_MSG = "Invalid mobile number";

// Readable display: "95237 55460". Falls back to the raw value.
export function formatPhone(input) {
  const n = normalizePhone(input);
  return n ? `${n.slice(0, 5)} ${n.slice(5)}` : String(input ?? "");
}

// WhatsApp needs country code: "91" + 10 digits.
export function waPhone(input) {
  const n = normalizePhone(input);
  return n ? `91${n}` : String(input ?? "").replace(/\D/g, "");
}

// onBlur / onPaste helper: returns the normalized value when valid, else the input unchanged.
export function cleanPhoneInput(input) {
  return normalizePhone(input) || String(input ?? "");
}
